import React from 'react';
import Modal from '../../styled-base/modal';
import WsDetailsPopup from '../../components/popup/wsDetailsPopup';

const WsDeatailsModal = (props:any) => {

    const BoardWsDataUpate = (obj: any) => {
        console.log('BoardWsDataUpate', obj);
        if (typeof props.boardWsDataUpate === 'function') {
            props.boardWsDataUpate(obj);
        }
    }

    return (
        <Modal width={750} classes='portal-modal-ws-details'>
            <Modal.Content>
                <WsDetailsPopup
                    item={props.item}
                    actions={{BoardWsDataUpate}}
                    saveCallback={props.saveCallback}
                    onClose={props.onClose}
                />
            </Modal.Content>
        </Modal>
    )
}

export default WsDeatailsModal;

